import {toast} from 'react-hot-toast';
import i18n from '../i18n';

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/jpg'];

export const validateFile = (file, t) => {
  // Check if file exists
  if (!file) {
    return false;
  }

  // Check file type
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    toast.error(t('common.invalidFileType'));
    return false;
  }

  // Check file size
  if (file.size > MAX_FILE_SIZE) {
    toast.error(t('common.fileSizeError'));
    return false;
  }

  return true;
};

export const getBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

export const handleFileUpload = async (
  e,
  setFile,
  setOriginalFile,
  setEditedView,
  t,
) => {
  const file = e.target.files[0];

  if (!validateFile(file, t)) {
    // Reset the input value to empty
    e.target.value = '';
    return false;
  }

  try {
    const base64 = await getBase64(file);
    setFile(base64);
    setOriginalFile(file); // Store the original file reference
    setEditedView(true);
    return true;
  } catch (error) {
    console.error('Error processing file:', error);
    toast.error(t('common.fileProcessingError'));
    // Reset the input value to empty on error
    e.target.value = '';
    return false;
  }
};
